import { DROP_CONFIG } from 'components/Drops/dropConfig';
import { firstWearableToken, mixpassToken } from 'components/Mixpass/mixpassConfig';
import { isDev } from 'utils/config';
import { useInfiniteQuery } from 'react-query';
import { fetchOwnedNfts } from 'utils/platformPublicApi';

const chainIds: number[] = isDev()
  ? [
      4, // Rinkeby
      80001, // Mumbai
    ]
  : [
      1, // Mainnet
      137, // Polygon
    ];
const contracts = [
  ...Object.values(DROP_CONFIG).map(d => d.contractAddress),
  mixpassToken.address,
  firstWearableToken.address,
];

const PAGE_LIMIT = 24;

export const useInfiniteOwnedEulerBeatsNfts = (
  address: string | null,
  limit?: number | null,
  queryConfig: any = {}
) => {
  return useInfiniteQuery(
    ['owned', address, limit],
    ({ pageParam = '' }) => {
      return fetchOwnedNfts(
        address ?? '',
        chainIds,
        contracts,
        undefined,
        limit ?? PAGE_LIMIT,
        pageParam
      );
    },
    {
      enabled: Boolean(address),
      getNextPageParam: (lastPage, pages) => (lastPage.has_more ? lastPage?.cursor : undefined),
      keepPreviousData: true,
      staleTime: 1000 * 60 * 2, // 2 minutes
      cacheTime: 1000 * 60 * 5, // 5 minutes
    }
  );
};
